define([
  "globals",
  "base-view-model",
  "jquery",
  "knockout",
  "postal",
  "underscore",
  "cookies-factory"
],
function (globals, baseViewModel, $, ko, postal, _, cookiesFactory ) {
    "use strict";

    var ProductChoiceViewModel = function (data, group, optionId) {
        var self = this;
        const { isSamplingEnabled, isSamplingEnabledCecOnly } = globals;
        ko.utils.extend(self, baseViewModel);

        var productPageChannel = postal.channel("productpage");
        self.globals = globals;
        self.group = group;
        self.name = data.ShortLabel;
        self.image = data.MediaUrl;
        self.selected = ko.observable(false);
        self.visible = ko.observable(true);
        self.id = data.ChoiceId;
        // This field is used for serverTemplate as Id
        self.choiceid = data.ChoiceId;
        self.optionId = optionId;
        self.isAvailable = data.IsAvailable;
        self.isSampleable = data.IsSampleable;
        self.sampleProductId = data.SampleProductId;
        self.variantId = data.SampleVariantId;
        self.shouldDisplaySampling = (isSamplingEnabled && !isSamplingEnabledCecOnly) || (cookiesFactory.isInternalUser() && isSamplingEnabledCecOnly);
        self.isUnavailableInSize = ko.observable(false);
        self.price = ko.observable(data.Price);

        self.priceDollars = ko.computed(function () {
            return Math.floor(self.price());
        });

        self.priceCents = ko.computed(function () {
            return self.price().toFixed(2).toString().split(".")[1];
        });

        self.sampleAvailable = ko.computed(function () {
            return self.isSampleable && self.isAvailable && self.shouldDisplaySampling;
        });

        this.sampleAdded = ko.observable(false);

        this.mouseoverPreview = function (color, event) {
            if (self.selected()) {
                var $target = $(event.currentTarget).parent();
                $target.prepend("<div class='bdc-choiceswatch-preview' style='background-image:url(" + self.image + "?width=290)'></div>");
            }
        };

        this.mouseoutPreview = function (color, event) {
            var $target = $(event.currentTarget).parent();
            $target.find(".bdc-choiceswatch-preview").remove();
        };

        this.addSample = function () {
            var sample = {
                productId: globals.productId,
                productName: globals.productName,
                productCategory: globals.productCategory,
                productBrand: globals.productBrand,
                optionId: self.optionId,
                choiceId: self.id,
                name: self.name,
                sampleProductId: self.sampleProductId,
                variantId: self.variantId
            };
            var message = (self.sampleAdded()) ? "sample.remove" : "sample.add";
            productPageChannel.publish(message, sample);
        };

    this.toggleSelected = function () {
        productPageChannel.publish("selection.changed", self);

        var selectedSwatch = buildSwatch();
        productPageChannel.publish("after.selection.change", selectedSwatch);

        var swatchSelectedEvent = new CustomEvent('swatchSelected', {
          detail: selectedSwatch,
        });

        document.dispatchEvent(swatchSelectedEvent);
    };

        var buildSwatch = function () {
            var selectedColor = { productId: globals.productId, optionId: self.selected() ? self.optionId : null, colorId: self.selected() ? self.id : null, optionType: null };

            _.find(globals.models.sampleOptions.Options, function (o) {
                if (o.OptionId === self.optionId) {
                    selectedColor.optionType = o.Type;
                }
            });
            return selectedColor;
        };

        productPageChannel.subscribe("selection.changed", function (selectedChoice) {
            if (selectedChoice.optionId === self.optionId && selectedChoice.id !== self.id) {
                self.selected(false);
            } else if (selectedChoice.id === self.id) {
                self.selected(!self.selected());
                if (self.selected()) {
                    self.group.selectedChoice = selectedChoice;
                } else {
                    self.group.selectedChoice = null;
                }
            }
        });

        productPageChannel.subscribe("sample.added", function (sample) {

            if (sample === self.id) {
                self.sampleAdded(true);
            }
        });

        productPageChannel.subscribe("sample.removed", function (sample) {
            if (sample === self.id) {
                self.sampleAdded(false);
            }
        });

        productPageChannel.subscribe("choice.price.updated", function (choicePrice) {
            if (choicePrice.choiceId === self.id) {
                self.price(choicePrice.price);
            }
        });
    }

    return ProductChoiceViewModel;
});
